<template>
  <v-dialog
    :value="value"
    persistent
    max-width="290"
    @input="onInput"
  >
    <v-card>
      <v-card-title class="text-h5">
        {{ history ? 'Restore Immigration Status' : 'Move to Immigration Status History' }}
      </v-card-title>
      <v-card-text>
        <template v-if="history">
          Would you like to restore <b>{{ subtitleImmigrationStatus }}</b> as the current Immigration Status?
        </template>
        <template v-else>
          Would you like to move <b>{{ subtitleImmigrationStatus }}</b> to Immigration Status History?
          It will no longer show as a current status.
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary darken-1"
          text
          @click="cancel"
        >
          No
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="confirm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ImmigrationStatusHistoryDialog',

  props: {
    history: {
      type: Boolean,
      default: false,
    },

    subtitleImmigrationStatus: {
      type: String,
      default: null,
    },

    value: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    cancel () {
      this.$emit('input', false)
    },

    confirm () {
      this.$emit('confirm')
    },

    onInput (value) {
      this.$emit('input', value)
    },
  },
}
</script>
